// Widget base: gráfica multi-línea (réplica de "Avg Price - Por Cadena").
// Una línea por serie (retailer). Reutiliza chart.js. Colores distintos por
// serie generados en HSL para soportar muchos canales.
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  Title, Tooltip, Legend,
} from 'chart.js';
import { formatValue } from '../format';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function colorFor(i, total) {
  const hue = Math.round((360 * i) / Math.max(total, 1));
  return `hsl(${hue}, 65%, 48%)`;
}

export default function MultiLineChart({ block, data, theme }) {
  const src = data?.[block.source] || { dates: [], series: [] };
  const labels = src.dates || [];
  let series = src.series || [];

  // Opcional: limitar # de líneas para legibilidad (las de mayor cobertura).
  if (block.maxSeries && series.length > block.maxSeries) {
    series = series.slice(0, block.maxSeries);
  }

  const datasets = series.map((s, i) => ({
    label: s.name,
    data: s.data,
    borderColor: colorFor(i, series.length),
    backgroundColor: 'transparent',
    borderWidth: 1.5,
    pointRadius: 0,
    pointHoverRadius: 4,
    tension: 0.25,
    spanGaps: true,
  }));

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'nearest', intersect: false },
    plugins: {
      legend: { display: true, position: 'bottom', labels: { boxWidth: 12, font: { size: 10 }, padding: 6 } },
      tooltip: {
        callbacks: { label: (ctx) => `${ctx.dataset.label}: ${formatValue(ctx.raw, block.format)}` },
      },
    },
    scales: {
      y: { ticks: { callback: (v) => formatValue(v, block.format), font: { size: 11 }, color: '#6b7280' }, grid: { color: '#eef2f5' } },
      x: { ticks: { font: { size: 10 }, color: '#6b7280', maxRotation: 0, autoSkip: true }, grid: { display: false } },
    },
  };

  return (
    <div className="vz-card">
      <div className="vz-card-title" style={{ background: theme.primary }}>{block.title}</div>
      <div className="vz-chart-body vz-chart-body--tall">
        {labels.length === 0
          ? <div className="vz-empty">Sin datos para los filtros seleccionados</div>
          : <Line data={{ labels, datasets }} options={options} />}
      </div>
    </div>
  );
}
